import { Box, styled } from '@mui/material';

export const DocumentMessageContent = styled('span', { shouldForwardProp: prop => prop !== 'color' })(({ theme, color }) => ({
  color: theme.palette[color]?.main
}));

export const DocumentMessagesWrapper = styled(Box, { shouldForwardProp: prop => prop !== 'active' })(({ theme, active }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  paddingInline: theme.spacing(2),
  paddingBlock: active ? theme.spacing(1) : 0
}));

export const DocumentMessageWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));
